module.exports = __webpack_public_path__ + "img/logo-credit-safe.fd9f5157.png";